export const BASE_URL = process.env.SERVER_URL || 'https://api.7pictures.io/';
